import { Component, OnInit, ViewChild } from '@angular/core';
import { CONSTANTES, getToken } from 'src/app/shared/global';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { OrderService } from 'src/app/services/order.service';
import { DataOrder } from 'src/app/models/DataOrder';
import { Router } from '@angular/router';
import { Clothes } from 'src/app/models/Clothes';
import { ModalDirective } from 'angular-bootstrap-md';
import { PinGroup } from 'src/app/models/PinGroup';

declare var jQuery: any;

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss']
})
export class MyOrdersComponent implements OnInit {
  public navImage = CONSTANTES.navBarImage;
  public listaOrders: string[] = [];
  public mapDetail = new Map();
  public listaClothes: {
    clothes: Clothes;
    size: string;
    amount: number
  }[] = [];
  public totalPoints: number;
  public cip: string;
  public title: string = "Consulta pedido";
  public teamJson : JSON;
  public orderNumber: string;
  public formTeams = new FormGroup({
    team: new FormControl(null, Validators.required),
  });
  public formOrders = new FormGroup({
    numOrder: new FormControl(null, Validators.required),
  });
  numOrder:any;
  public imagesUrl: string = CONSTANTES.imagesUrl;

  public myCintura: string;
  public myTorax: string;
  public pinGroup: PinGroup = new PinGroup();
  public pinObservation: string;
  public myAltura: string;
  public weaponData :String;
  public jobData :String;
  public ribbonData :String;
  public generalStaffData :String;
  public observationData :String;
  @ViewChild('observationModal') observationModal: ModalDirective;
  @ViewChild('measuresModal') measuresModal: ModalDirective;
  @ViewChild('pinModal') pinModal: ModalDirective;
  imagesUrlPins = CONSTANTES.pasadoresUrl;

  constructor(private orderService: OrderService, private spinner: NgxSpinnerService, private toastr: ToastrService, private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);

    this.spinner.show();

    let data: DataOrder = new DataOrder();
    data.nid = localStorage.getItem("nid");
    data.status = "FINISHED"
    data.role = localStorage.getItem("role");
    
    //Se solicitan todos los pedidos del usuario que se encuentren finalizados
    this.orderService.getOrderByUser(data).subscribe(
      data => {
        if (getToken(data)) {
          if(data.orders!=null){
            for (let i = 0; i < data.orders.length; i++) {
              this.listaOrders.push(data.orders[i].orderNumber);
              this.mapDetail.set(data.orders[i].orderNumber, data.orders[i]);
            }        
            this.spinner.hide();
          }else{
            this.toastr.info("NO EXISTEN PEDIDOS", "INFO");
            this.spinner.hide();
            this.router.navigate(['home']);
          }

        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS PEDIDOS", "ERROR");
      }
    )
  }

  postOrder(orderNumber: string) {
    this.totalPoints=0;
    this.spinner.show();
    this.orderNumber = orderNumber;
    this.listaClothes = this.mapDetail.get(orderNumber).orderDetails;
    this.listaClothes.forEach(element => {
      this.totalPoints += element.clothes.prices[0].price * element.amount;
    });
    //this.totalPoints = this.mapDetail.get(orderNumber).price;
    this.spinner.hide();
  }

  //Genera el justificante del pedido
  print(){
    let data: DataOrder = new DataOrder();
    data.nid = localStorage.getItem("nid");
    data.orders = [this.mapDetail.get(this.orderNumber)]; 
    data.role = localStorage.getItem("role");
    this.orderService.getReceiptOrders(data).subscribe(
      data => {
        if (getToken(data)) {
          if(data.receiptOrders!=null){
            const source = 'data:application/pdf;base64,'+data.receiptOrders;
            const link = document.createElement("a");
            link.href = source;
            if(localStorage.getItem("role")!=='INDIVIDUO'){
              link.download = 'ticket'+new Date()+'+.pdf';
            }else{
              link.download = 'justificante.pdf';
            }
            link.click();
            this.spinner.hide();
          }else{
            if(localStorage.getItem("role")!=='INDIVIDUO'){
              this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL TICKET", "ERROR");
            }else{
              this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "ERROR");
            }            
            this.spinner.hide();
            this.router.navigate(['home']);
          }

        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
        }
      },
      error => {
        this.spinner.hide();
        if(localStorage.getItem("role")!=='INDIVIDUO'){
          this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL TICKET", "ERROR");
        }else{
          this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "ERROR");  
        }
      }
    )
  }

  openObservation(index: number){
    this.jobData = this.mapDetail.get(this.orderNumber).orderDetails[index].job.description;
    this.ribbonData = this.mapDetail.get(this.orderNumber).orderDetails[index].ribbon.description;
    this.generalStaffData = this.mapDetail.get(this.orderNumber).orderDetails[index].generalStaff.description;
    this.weaponData = this.mapDetail.get(this.orderNumber).orderDetails[index].weapon.description;
    this.observationData = this.mapDetail.get(this.orderNumber).orderDetails[index].observation;
    this.observationModal.show();
  }
  
  openMeasures(index: number){
    this.myAltura = this.mapDetail.get(this.orderNumber).orderDetails[index].height;
    this.myCintura= this.mapDetail.get(this.orderNumber).orderDetails[index].waist;
    this.myTorax = this.mapDetail.get(this.orderNumber).orderDetails[index].thorax;
    this.measuresModal.show();
  }

  openPin(index: number){
    this.pinGroup = this.mapDetail.get(this.orderNumber).orderDetails[index].pinGroup;
    this.pinObservation = this.mapDetail.get(this.orderNumber).orderDetails[index].pinObservation;
    this.pinModal.show();
  }

  infoObservation(index: number){
    let result: boolean;

    if(this.mapDetail.get(this.orderNumber).orderDetails[index].job!==null){
      result =  true
    }else{
      result = false;
    }
    return result;
  }

  infoMeasures(index: number){
    let result: boolean;
    if(this.mapDetail.get(this.orderNumber).orderDetails[index].waist!==null){
      result =  true
    }else{
      result = false;
    }
    return result;
  }

  infoPin(index: number){
    let result: boolean;
    if(this.mapDetail.get(this.orderNumber).orderDetails[index].pinGroup !==null){
      result =  true
    }else{
      result = false;
    }
    return result;
  }

}
